var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ctint-contact-account-update',{attrs:{"namespace":_vm.namespace,"params":_vm.contactAccountParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }